import { DomHelper } from '../modules/DomHelper';

/**
 * SmoothScroll — アンカーリンクのスムーズスクロール
 * CSS scroll-behavior: smooth が使えない場合のフォールバック
 * ヘッダーオフセット対応
 *
 * HTML:
 *   <a href="#section-id" class="js-smooth-scroll">スクロール</a>
 */
export class SmoothScroll {
  private readonly offset: number;

  constructor(options?: { offset?: number; headerSelector?: string }) {
    const { offset, headerSelector = '.l-header' } = options ?? {};

    if (offset !== undefined) {
      this.offset = offset;
    } else {
      // ヘッダー高さを動的に取得
      const header = DomHelper.qs<HTMLElement>(headerSelector);
      this.offset = header ? header.offsetHeight : 0;
    }

    this.init();
  }

  private init(): void {
    document.addEventListener('click', (e) => {
      const target = (e.target as Element).closest<HTMLAnchorElement>(
        '.js-smooth-scroll, a[href^="#"]'
      );
      if (!target) return;

      const href = target.getAttribute('href');
      if (!href || href === '#') return;

      const destination = document.querySelector(href);
      if (!destination) return;

      e.preventDefault();
      this.scrollTo(destination as HTMLElement);

      // URL ハッシュ更新
      history.pushState(null, '', href);

      // GTM イベント
      DomHelper.pushDataLayer({
        event: 'smooth_scroll',
        scroll_target: href,
      });
    });
  }

  scrollTo(target: HTMLElement): void {
    const targetTop = target.getBoundingClientRect().top + window.scrollY - this.offset;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth',
    });
  }
}
